import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const AmazonConnectIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props}>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="amazon-connect-gradient"
        x1="6"
        x2="2006"
        y1="2006"
        y2="6"
      >
        <stop stopColor={preserveColor ? '#2E27AD' : 'currentColor'} />
        <stop
          offset="1"
          stopColor={preserveColor ? '#527FFF' : 'currentColor'}
        />
      </linearGradient>
    </defs>
    <path
      d="M6 6h20v20H6V6Z"
      fill={preserveColor ? 'url(#amazon-connect-gradient)' : 'transparent'}
    />
    <path
      d="M18.689 15.258a.503.503 0 0 1-.5-.504c0-.278.224-.504.5-.504s.5.226.5.504a.503.503 0 0 1-.5.504Zm-2.5 2.52a.503.503 0 0 1-.5-.505c0-.277.223-.504.5-.504.276 0 .5.227.5.504a.503.503 0 0 1-.5.504Zm-2-3.024a.503.503 0 0 1-.5-.504c0-.278.223-.504.5-.504.275 0 .5.226.5.504a.503.503 0 0 1-.5.504Zm-2 2.52a.503.503 0 0 1-.5-.505c0-.277.223-.504.5-.504.275 0 .5.227.5.504a.503.503 0 0 1-.5.504Zm6.5-3.528a1.005 1.005 0 0 0-.86 1.514l-1.098 1.169a.99.99 0 0 0-.543-.164c-.035 0-.07.007-.105.01l-1.015-1.556a1 1 0 1 0-1.875-.378c.018.186.087.363.2.512l-.946.947a.996.996 0 0 0-.258-.038c-.552 0-1 .452-1 1.008a1.005 1.005 0 0 0 1 1.008 1.01 1.01 0 0 0 .709-1.718l.888-.889a.983.983 0 0 0 .402.087.986.986 0 0 0 .531-.157l.885 1.359a1.007 1.007 0 0 0 .585 1.822 1.005 1.005 0 0 0 .879-1.478l1.113-1.186c.15.09.322.144.508.144.551 0 1-.452 1-1.008a1.005 1.005 0 0 0-1-1.008Zm1.811 5.04h-2.25a.247.247 0 0 0-.148.05l-3.914 2.913v-2.712a.251.251 0 0 0-.25-.252H11.18c-.224 0-.436-.062-.612-.18-.487-.326-1.068-.945-1.068-2.045 0-1.508 1.044-2.003 1.667-2.163a.252.252 0 0 0 .188-.26l-.026-.414c0-1.202.824-2.494 1.876-2.943.473-.202.91-.282 1.307-.282 1.127 0 1.924.65 2.271 1.001.383.387.682.881.887 1.469a.248.248 0 0 0 .332.148.25.25 0 0 0 .106-.083 1.194 1.194 0 0 1 1.337-.441c.55.183.866.726.865 1.481a.251.251 0 0 0 .205.284c.597.103 1.985.527 1.985 2.224 0 2.021-1.936 2.198-2 2.204Zm.306-4.883c-.051-.891-.494-1.553-1.204-1.79a1.68 1.68 0 0 0-1.608.312 4.223 4.223 0 0 0-.857-1.282c-1.127-1.14-2.67-1.45-4.127-.827-1.243.53-2.18 1.995-2.18 3.422l.014.23C10.166 14.19 9 14.827 9 16.56c0 1.393.809 2.142 1.291 2.464.259.173.566.265.889.265h2.508v2.96a.252.252 0 0 0 .25.251.246.246 0 0 0 .149-.05l4.245-3.161h2.186c.026-.003 2.482-.215 2.482-2.708 0-1.923-1.485-2.508-2.194-2.678Z"
      fill={preserveColor ? '#fff' : undefined}
    />
  </BaseIcon>
);
